module.exports = __webpack_public_path__ + "static/media/PostmanTestPreview.5aef9180.png";